import React from 'react'

export default function TextContainer(props) {
  return (
    <div className={props.class}>{props.text}</div>
  )
}
